import React, { useEffect, useState } from 'react'
import { FcViewDetails } from 'react-icons/fc';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { SortingRule } from 'react-table';
import { Col, Row} from 'reactstrap';
import ButtonComponent from '../../components/ButtonComponent';
import InputComponent from '../../components/InputComponent';
import Layout from '../../components/Layout/Layout';
import PageTitle from "../../components/Layout/PageTitle";
import TableComponent from '../../components/TableComponent';
import RoutesObject from '../../helpers/Routes';
import Toast from '../../helpers/Toast';
import { Utilities } from '../../helpers/Utilities';
import { FileTypeDTO } from '../../models/File/FileTypeDTO';
import { Parameter } from '../../models/Parameter';
import { Tooltip } from '@mui/material';
import { FileTypeService } from '../../services/FileTypeService';

function FileTypesIndex() {
    const intl = useIntl()
    const pageSizes: number[] = [5, 10, 15, 30];
    const [data, setData] = useState<FileTypeDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const navigate = useNavigate();
    const service = new FileTypeService();
  
    const [currentPage, setCurrentPage] = useState<number>();
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);
    const [reloadSearch, setReloadSearch] = useState<boolean>(false);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);
  
    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes, 10));
  
    const [goToPage, setGoToPage] = useState<number>();
  
    const [name, setName] = useState<string>(Utilities.LoadParameterFromURLQuery("name", "string", ""));
  
    const columns = React.useMemo(
      () => [
          {
              Header: "",
              accessor: " ",
              width: 5,
              Cell: (props: any) => {
                  return (
                      <Tooltip
                          title="Ver Detalhes"
                          aria-label="Ver Detalhes"
                          enterNextDelay={500}
                          enterDelay={500}>
                          <div
                              style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer"
                              }}
                              onClick={() => { navigate(`${RoutesObject.fileTypes.details}/${props.cell.row.original.id}`)}}
                          >
                              <FcViewDetails className="icons" />
                          </div>
                      </Tooltip>
                  );
              },
          },
          {
              Header: "Nome",
              accessor: "name",
              width: 95,
          },
      ],
      [isButtonCreateLoading],
  );
  
  const fetchData = async (page: number, pageSize: number, sortBy: SortingRule<object>[] | null) => {
    var searchUrl: string = Utilities.CreateSearchURL([
        `page=${page}`,
        `pageSize=${pageSize}`,
        Utilities.AddParamToQueryIfValue("name", "string", name),
    ]);
    if (sortBy != null && sortBy.length > 0) {
        searchUrl += `${Utilities.AddParamToQueryIfValue("sortField", "string", sortBy[0].id)}${Utilities.AddParamToQueryIfValue(
            "sortOrder", "string", sortBy[0].desc === true ? "DESC" : "ASC",
        )}`;
    }
    navigate({
        pathname: "/fileTypes",
        search: searchUrl,
    });
  
    setLoading(true);
    var response = await service.GetAllPaginated(
        mountSearchParameters(),
        Utilities.MountSortParameters(sortBy),
        page,
        pageSize,
    );
  
    if (response.success !== true) {
        setCurrentPage(1);
        setGoToPage(1);
        setData([]);
        setPageCount(0);
        setLoading(false);
        setCurrentSorting(null);
        Toast.Show("error", response.message);
        return;
    }
    if (response.items.length === 0)
    {
        setCurrentPage(1);
        setGoToPage(1);
        Toast.Show("success", "Não existe nenhuma setting com esses dados");
    }
    setData(response.items);
    setPageCount(response.totalPages);
    setLoading(false);
    setCurrentPageSize(pageSize);
    setCurrentPage(page);
    setCurrentSorting(sortBy);
    setGoToPage(0)
  
    if (response.totalPages > 0 && page > response.totalPages) {
        setGoToPage(1);
    }
  };
  
  const mountSearchParameters = (): Parameter[] => {
    var parameters: Parameter[] = [];
    parameters.push(new Parameter("name", name));
    
    return parameters;
  };
  
  const onRemoveFiltersClick = () => {
    setCurrentPage(1);
    setGoToPage(1);
    setName("");
    setReloadSearch(true);
  }
  
  const onEnter = () => {
    fetchData(currentPage ?? 1, currentPageSize ?? 10, currentSorting);
  };
  
  const onButtonClick = () => {
    setCurrentPage(1);
    setGoToPage(1);
    fetchData(currentPage ?? 1, currentPageSize ?? 10, currentSorting);
  }
  
  useEffect(() => {
    if (reloadSearch === true) {
        fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
        setReloadSearch(false);
    }
  }, [reloadSearch]);
  
    return (
      <Layout>
      <div className="pageContainer">
            <div className="pageHeader">
                <span className="pageTitle">
                    <FormattedMessage id="Screens.FileType.Title" />
                </span>
            </div>
          <div className='pageBody'>
              <Row>
                  <InputComponent xl={2} lg={3} md={5} sm={12} xs={12}
                      style={{ width: "100%" }}
                      type={"text"}
                      label={intl.formatMessage({ id: "Screens.Settings.Filters.Name"})}
                      readOnly={false}
                      value={name}
                      onEnter={onEnter}
                      onChange={(t: string) => setName(t)}
                  />
              </Row>
              <Row>
                  <Col xl={3} lg={3} md={3} sm={12} xs={12}
                      style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
                      <ButtonComponent
                          text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                          onClick={onButtonClick}
                      />
                      <ButtonComponent
                          text={intl.formatMessage({ id: "Common.Buttons.RemoveFilters" })}
                          onClick={onRemoveFiltersClick}
                      />
                  </Col>
              </Row>
  
              <div className="pageComponent" style={{ width: "100%" }}>
                  <TableComponent
                      goToPage={goToPage}
                      loading={loading}
                      pageCount={pageCount}
                      columns={columns}
                      manualPagination={true}
                      fetchData={fetchData}
                      pageSizes={pageSizes}
                      initialPage={page}
                      initialPageSize={pageSize}
                      initialSortBy={initialSortBy}
                      data={data}
                      dontOrderFirstCollumn={true}
                  />
              </div>
          </div>
      </div>
  </Layout>
    )
}

export default FileTypesIndex